import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of, from} from 'rxjs';
import {map, concatMap, toArray, mergeMap} from 'rxjs/operators';
import {ArtfactKind, NickCalculate} from '@mrp-brasil/nick-data-commons';

@HookClass('condition')
export class ConditionHook extends BaseHook {

    @Hook('427a8859-3ea5-4b62-8237-9329ab109639')
    public conditionHook(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const condition = inputArtifact.object.condition ?? inputArtifact.object;
        const returnConditions = inputArtifact.object.returnConditions

        const resultsArray: any[] = [];

        const evaluateCondition = (cond: any): Observable<boolean> => {
            if (cond.conditions && Array.isArray(cond.conditions)) {
                const sortedConditions = [...cond.conditions].sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
                return from(sortedConditions).pipe(
                    mergeMap((subCond: any) => evaluateCondition(subCond)),
                    toArray(),
                    map((results: boolean[]) => {
                        let result: boolean;

                        switch (cond.$op) {
                            case '$or':
                                result = results.some(r => r);
                                break;
                            case '$xor':
                                result = results.filter(Boolean).length === 1;
                                break;
                            case '$and':
                            default:
                                result = results.every(r => r);
                                break;
                        }

                        resultsArray.push({
                            kind: 'group',
                            id: cond.id,
                            result: result
                        });

                        return result
                    })
                );
            } else {
                let valueA = cond.valueA;
                let valueB = cond.valueB;

                if (cond.valueAField)
                    valueA = (cond.valueAField.split('.') as any[]).reduce((o, i) => (o ? o[i] : o), inputArtifact.object.data);
                if (cond.valueBField)
                    valueB = (cond.valueBField.split('.') as any[]).reduce((o, i) => (o ? o[i] : o), inputArtifact.object.data);

                const result = NickCalculate.applyCondition(valueA, valueB, cond.conditionKind)

                resultsArray.push({
                    kind: 'condition',
                    id: cond.id,
                    result: result
                });

                return of(result);
            }
        };

        return evaluateCondition(condition).pipe(
            map((conditionResult: boolean) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;

                if (returnConditions) {
                    outputArtifact.object = {
                        result: conditionResult,
                        conditions: resultsArray
                    };
                } else {
                    outputArtifact.object = conditionResult;
                }

                return outputArtifact;
            })
        );
    }

    @Hook('e7c929fd-b5bf-4202-8aa5-17aea6463065')
    public reduceToValue(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = inputArtifact.object.config.attribute.split('.').reduce((result: any, item: any) => (result ? result[item] : result), inputArtifact.object.data);
        return of(outputArtifact);
    }
}
